// updateDataToIntercom.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import { push as customerServicePush } from '../resource/customerService.js';

/**
 * Update data to intercom
 * @kind action
 * @return {Promise} Action promise.
 */
const updateDataToIntercom = () => async (dispatch, getState) => {
  if (!window.Intercom) {
    return dispatch({ type: '' });
  }

  const pusherState = getOperationData(getState(), ['pusher'], 'state');
  const pusherSocketId =
    getOperationData(getState(), ['pusher'], 'socketId') || 'null';

  customerServicePush({
    args: [
      'update',
      {
        webapp_pusher_state: pusherState?.connection || 'null',
        webapp_pusher_socket_id: pusherSocketId,
      },
    ],
  });
};

export default updateDataToIntercom;
